import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=0496b342&scoped=true&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=0496b342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496b342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0496b342')) {
      api.createRecord('0496b342', component.options)
    } else {
      api.reload('0496b342', component.options)
    }
    module.hot.accept("./RegisterForm.vue?vue&type=template&id=0496b342&scoped=true&", function () {
      api.rerender('0496b342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/RegisterForm.vue"
export default component.exports